import { Lightning, MoneyCircle, Scales, World } from '@js/web/components/icons';

export const weeklyAboutContent = {
  title: ['How it Works.', 'Weekly Sunday Auction.'],
  body: [
    'Our flagship auction venue offers maximum item-diversity and liquidity for collectors and investors to buy and sell 24/7/365. There is always an auction running! Events start every Thursday at 7:00 p.m. PT and close 10 days later on Sunday evening. Extended bidding begins on Sunday at 7:00 p.m. PT.',
    'The Weekly Sunday Auction leverages a patent-pending extended bidding period, designed to create a fair, fast-paced, and engaging auction closing experience. Auction items close quickly via closing windows, which become increasingly brief as extended bidding progresses. The first closing window ends promptly at 7:30 p.m. PT, so get ready! Most items sell prior to 8:00 p.m. PT.'
  ],
  textSide: 'left',
  backgroundColor: 'white',
  imageUrlDesktop: jsConfig.links.imagesUrl + 'about-weekly-experience-desktop.png',
  imageUrlMobile: jsConfig.links.imagesUrl + 'about-weekly-experience-mobile.png',
  titleType: 'h1',
  overflowImage: false,
  noAssetBackground: true,
  containImage: true
}

export const weeklyFees = {
  hasBorderTop: true,
  smallTitle: true,
  title: 'Commission Example',
  priceSections: [
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$250</b></span></div>',
      label: 'Hammer / final bid amount',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$250 + 4%</b></span></div>',
      label: 'Seller receives a bonus commission + hammer amount',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$260</b></span></div>',
      label: 'Total seller commission received',
    },
  ],
  showSubmitButton: false
};

export const weeklyTripleIconMessages = [
  {
    icon: World,
    iconColor: '#FFF',
    iconBgColor: ' linear-gradient(117.62deg, #1D72ED -6.56%, rgba(18, 123, 229, 0.3) 167.87%);',
    title: ['World\'s #1 Auction Venue'],
    message: 'As expansive as the trading card market itself. The #1 auction venue for quantity, quality, and diversity.'
  },
  {
    icon: MoneyCircle,
    iconColor: '#FFF',
    iconBgColor: ' linear-gradient(117.62deg, #1D72ED -6.56%, rgba(18, 123, 229, 0.3) 167.87%);',
    title: ['Liquidity'],
    message: 'Speed to market and efficient portfolio building. Maximum flexibility to buy and sell.'
  },
  {
    icon: Lightning,
    iconColor: '#FFF',
    iconBgColor: ' linear-gradient(117.62deg, #1D72ED -6.56%, rgba(18, 123, 229, 0.3) 167.87%);',
    title: ['Flash Auction'],
    message: 'Time the market and control the selling schedule! Members can Flash any Vaulted asset into an active Weekly Sunday Auction.'
  },
  {
    icon: Scales,
    iconColor: '#FFF',
    iconBgColor: ' linear-gradient(117.62deg, #1D72ED -6.56%, rgba(18, 123, 229, 0.3) 167.87%);',
    title: ['Authentication Services'],
    message: 'First of it\'s kind. Submit your ungraded/raw trading cards and receive a seamless connection between professional authentication and our marketplaces. We offer professional grading through our partnerships with industry leading companies, where assets go straight to auction. We also offer authentication services for raw cards submitted to your Vault. All raw cards are charged the same low fee for the respective service, regardless of individual item value.'
  },
];

export const weeklyDescription = {
  body: [
    '<p>A fun and competitive auction marketplace, Fanatics Collect designed the Weekly Sunday Auction from scratch for the trading card market. All auction items are easily searched and evaluated using our patent-pending auction software. Extended bidding starts at 7:00 p.m. PT every Sunday and items close according to specific closing windows. Items close when they fail to receive a single bid during the active closing window. Closing windows shrink as the night ensues with the first window ending at 7:30 p.m. PT. Nearly all items will close before 8:00 p.m. PT, so get ready to compete!</p>',
    '<p class="mb-4"><b>Buyers need only login/register to gain unlimited access to the marketplaces. Track your bids seamlessly from the Members portal and trade like a pro!</b></p>',
    '<p class="mb-4">Buyers are afforded free lifetime Fanatics Vault services on every purchase. Avoid costly shipping fees and sales taxes too! All items, regardless of category or value, receive free Vault, free shipping, and zero sales tax.</p>',
    '<p class="mb-0">A 20% buyer\'s premium is added to the hammer price on all sales.</p>',
  ],
  title: 'Bidding In The Weekly Sunday Auction',
  desktopImage: jsConfig.links.imagesUrl + 'weekly-auction-calendar-desktop.png',
  mobileImage: jsConfig.links.imagesUrl + 'weekly-auction-calendar-mobile.png',
  darkButtonLink: jsConfig.links?.weeklyUrl,
  darkButtonText: 'View Auction',
};
